import { styled } from "styletron-react";

const SubTextContainer = styled("span", () => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-end",
}));

export { SubTextContainer };
